/**
 * ErrorBanner - Displays account errors in a dismissible banner
 * Production-grade error display for user visibility
 */
import { Box, Alert, AlertTitle, IconButton, Collapse, Stack } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useAccount, type AccountError } from "../../context/AccountContext";

export function ErrorBanner() {
  const { errors, dismissError } = useAccount();

  // Only show non-dismissed errors
  const visibleErrors = errors.filter((e) => !e.dismissed);

  if (visibleErrors.length === 0) return null;

  return (
    <Stack spacing={1} sx={{ mb: 2 }}>
      {visibleErrors.map((error) => (
        <Collapse key={error.id} in={!error.dismissed}>
          <Alert
            severity="error"
            sx={{
              borderRadius: "12px",
              "& .MuiAlert-message": { flex: 1 },
            }}
            action={
              <IconButton
                aria-label="dismiss"
                color="inherit"
                size="small"
                onClick={() => dismissError(error.id)}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            <AlertTitle sx={{ fontWeight: 700, mb: 0.5 }}>
              {error.context ? `Error: ${error.context}` : "Something went wrong"}
            </AlertTitle>
            {error.message}
            {error.code && (
              <Box
                component="span"
                sx={{
                  display: "block",
                  fontSize: "11px",
                  opacity: 0.7,
                  mt: 0.5,
                }}
              >
                Error code: {error.code}
              </Box>
            )}
          </Alert>
        </Collapse>
      ))}
    </Stack>
  );
}
